"use client";

import React, { useEffect, useRef, useState } from "react";
import { AspectRatio } from "@/components/ui/aspect-ratio";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
const galleryImagesCol1 = [{
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1660464/img/eagle_roof_detail_1.png",
  alt: "High-quality roof shingle installation"
}, {
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1660464/img/eagle_siding_texture_2.png",
  alt: "Modern siding texture close-up"
}, {
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1660464/img/eagle_gutter_system_3.png",
  alt: "Seamless gutter system installation"
}];
const galleryImagesCol2 = [{
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1660464/img/eagle_exterior_finish_4.png",
  alt: "Completed home exterior renovation"
}, {
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1660464/img/eagle_storm_repair_5.png",
  alt: "Professional storm damage restoration"
}, {
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1660464/img/eagle_contractor_quality_6.png",
  alt: "Eagle Exteriors craftsmanship detail"
}];
export default function TheVectrPhilosophy() {
  const sectionRef = useRef<HTMLElement>(null);
  const [scrollProgress, setScrollProgress] = useState(0);
  useEffect(() => {
    const handleScroll = () => {
      if (!sectionRef.current) return;
      const rect = sectionRef.current.getBoundingClientRect();
      const windowHeight = window.innerHeight;
      const scrolled = windowHeight - rect.top;
      const total = windowHeight + rect.height;
      const progress = Math.max(0, Math.min(1, scrolled / total));
      setScrollProgress(progress);
    };
    window.addEventListener("scroll", handleScroll, {
      passive: true
    });
    handleScroll();
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);
  const grainOverlay = `url("data:image/svg+xml,%3Csvg viewBox='0 0 200 200' xmlns='http://www.w3.org/2000/svg'%3E%3Cfilter id='noiseFilter'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='0.85' numOctaves='3' stitchTiles='stitch'/%3E%3C/filter%3E%3Crect width='100%25' height='100%25' filter='url(%23noiseFilter)'/%3E%3C/svg%3E")`;
  return <section data-section-id="223697" id="our-commitment-to-quality" ref={sectionRef} className="bg-background text-foreground relative w-full overflow-hidden">
      <div className="container mx-auto px-6 md:px-12 lg:px-24">
        <div className="flex flex-col lg:flex-row gap-16 lg:gap-24 relative min-h-screen">
          
          {}
          <div className="lg:w-5/12 lg:sticky lg:top-0 lg:h-screen flex flex-col justify-center py-24 z-10">
            <div className="mb-12">
              <span className="font-default text-6xl lg:text-8xl font-bold tracking-tighter text-primary">
                01
              </span>
            </div>
            
            <h2 className="font-default text-3xl md:text-4xl lg:text-[2.5rem] font-bold leading-[1.15] tracking-tight text-foreground">
              Built on <span className="text-primary">Trust</span>, Covered by <span className="font-bold">Excellence</span>.
            </h2>
            
            <p className="mt-8 text-foreground text-lg max-w-md font-default leading-relaxed">
              Eagle Exteriors provides premium roofing and siding solutions designed to withstand the elements. Our local expertise ensures your home remains protected with the highest standards of craftsmanship.
            </p>

            <div className="mt-12">
              <Button asChild variant="outline" size="lg" className="rounded-none border-primary bg-primary text-primary-foreground hover:bg-foreground hover:text-background hover:border-foreground transition-all duration-300 uppercase tracking-widest font-default text-xs font-semibold">
                <Link to="/ContactPage">
                  Book Estimate
                </Link>
              </Button>
            </div>
          </div>

          {}
          <div className="lg:w-7/12 py-12 lg:py-32 flex gap-4 md:gap-8 relative z-0">
            
            {}
            <div className="flex-1 flex flex-col gap-4 md:gap-8 will-change-transform" style={{
            transform: `translateY(${scrollProgress * -250}px)`,
            transition: 'transform 0.1s ease-out'
          }}>
              {galleryImagesCol1.map((img, i) => <div key={`col1-${i}`} data-index={i} className="relative w-full overflow-hidden bg-card group rounded-[6px] shadow-lg">
                  <AspectRatio ratio={3 / 4}>
                    <div className="absolute inset-0 z-10 opacity-10 mix-blend-overlay pointer-events-none" style={{
                  backgroundImage: grainOverlay
                }} />
                    <img src={img.src} alt={img.alt} className="object-cover w-full h-full transition-all duration-700 ease-in-out group-hover:scale-105" />
                    <div className="absolute inset-0 bg-foreground/5 group-hover:bg-transparent transition-colors duration-700 z-0" />
                    {i === galleryImagesCol1.length - 1 && <div className="absolute bottom-0 right-0 w-16 h-16 border-b-8 border-r-8 border-primary z-20" />}
                  </AspectRatio>
                </div>)}
            </div>

            {}
            <div className="flex-1 flex flex-col gap-4 md:gap-8 mt-24 md:mt-48 will-change-transform" style={{
            transform: `translateY(${scrollProgress * -100}px)`,
            transition: 'transform 0.1s ease-out'
          }}>
              {galleryImagesCol2.map((img, i) => <div key={`col2-${i}`} data-index={i} className="relative w-full overflow-hidden bg-card group rounded-[6px] shadow-lg">
                  <AspectRatio ratio={3 / 4}>
                    <div className="absolute inset-0 z-10 opacity-10 mix-blend-overlay pointer-events-none" style={{
                  backgroundImage: grainOverlay
                }} />
                    <img src={img.src} alt={img.alt} className="object-cover w-full h-full transition-all duration-700 ease-in-out group-hover:scale-105" />
                    <div className="absolute inset-0 bg-foreground/5 group-hover:bg-transparent transition-colors duration-700 z-0" />
                  </AspectRatio>
                </div>)}
            </div>

          </div>
        </div>
      </div>
    </section>;
}